"use strict"
;(() => {
    let allCheckboxes
    let expandedDistrict = false
    let checkboxesDistricts = document.getElementById("checkboxesDistricts");
    let districtOption = document.getElementById("districtOption");
    let showCheckboxesDistricts = document.getElementById("showCheckboxesDistricts");

    showCheckboxesDistricts.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        toggleExpandOptions();
    });

    showCheckboxesDistricts.addEventListener("keydown", (event) => {
        if (event.key === "Enter") {
            event.preventDefault();
            toggleExpandOptions();
        }
    });

    const toggleExpandOptions = () => {
        if (!expandedDistrict) {
            checkboxesDistricts.style.display = "block";
            districtOption.style.boxShadow = "0 4px 8px 0 rgba(41, 41, 41, .16)";
            expandedDistrict = true;
        } else {
            checkboxesDistricts.style.display = "none";
            districtOption.style.boxShadow = "0 4px 8px 0 rgba(41, 41, 41, .16)";
            expandedDistrict = false;
        }
    }

    let toggleCheck = (e) => {
        e.stopPropagation()
        changeOptionText();
    }

    
    document.addEventListener("DOMContentLoaded", () => {

        changeOptionText();
        allCheckboxes.forEach((checkbox) => {
            checkbox.addEventListener("click", toggleCheck)
        })
    })

    document.getElementById("buttonClose").addEventListener("click", (event) => {
        event.preventDefault()
        event.stopPropagation()
        checkboxesDistricts.style.display = "none";
        districtOption.style.boxShadow = "unset";
        expandedDistrict = false;
    });

    document.getElementById("buttonChoose").addEventListener("click", (event) => {
        event.preventDefault()
        event.stopPropagation()
        checkboxesDistricts.style.display = "none";
        districtOption.style.boxShadow = "unset";
        expandedDistrict = false;
    });

    document.getElementById("buttonReset").addEventListener("click", (event) => {
        event.preventDefault()
        event.stopPropagation()
        allCheckboxes = document.querySelectorAll("#checkboxesDistricts input");
        allCheckboxes.forEach(input => {
            input.checked = false
        });
        changeOptionText();
    });


    const changeOptionText = () => {
        allCheckboxes = document.querySelectorAll("#checkboxesDistricts input");
        let numChecked = 0
        allCheckboxes.forEach(input => {
            if (input.checked) {
                numChecked++;
            }
        });

        const selectElement = document.getElementById('districtOption');

        const optionElement = selectElement.querySelector('option');

        const controlsClose = document.getElementById("controlsClose")
        const controlsChoose = document.getElementById("controlsChoose")

        let textOption = ""
        if (numChecked == 0) {
            textOption = 'bitte auswählen';
            controlsChoose.style.display = 'none';
            controlsClose.style.display = 'flex';
        } else {
            textOption = `${numChecked} von 23 ausgewählt`;
            controlsClose.style.display = 'none';
            controlsChoose.style.display = 'flex';
        }

        optionElement.textContent = textOption
    }

    document.addEventListener("click", (event) => {
        let targetElement = event.target;

        if (!checkboxesDistricts.contains(targetElement)) {
            checkboxesDistricts.style.display = "none";
            districtOption.style.boxShadow = "unset";
            expandedDistrict = false;
        }
    });

})()
